import React from 'react';
import { array, func, object, oneOfType, node, string, bool } from 'prop-types';
import { List } from '../..';
import { Box } from '../../../atoms';
import { Container, ResultsTermsContainer } from './top-terms-container.styles';

const listIndexIcon = index => {
  return /*#__PURE__*/React.createElement(Box, {
    bg: "background.primary",
    p: 2,
    borderRadius: 2
  }, index);
};

const TopTermsContainer = ({
  desktopMode,
  list,
  label,
  handleClickTopTerm
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "top-terms-container",
    desktopMode: desktopMode,
    isEmpty: list.length === 0
  }, /*#__PURE__*/React.createElement(ResultsTermsContainer, {
    isEmpty: list.length === 0
  }, list.length > 0 && /*#__PURE__*/React.createElement(List, {
    divided: true
  }, /*#__PURE__*/React.createElement(List.Header, {
    "data-testid": "top-terms-header",
    fontSize: 1,
    fontWeight: "bold",
    color: "text.scratched",
    pb: 2,
    mb: 1
  }, label), list.map((topTerm, index) => /*#__PURE__*/React.createElement(List.Item, {
    "data-testid": "top-terms-item",
    key: `top-term-${index}`,
    startIcon: listIndexIcon(index + 1),
    fill: "red",
    onClick: e => handleClickTopTerm(e, topTerm),
    fontSize: 2
  }, topTerm.term)))));
};

process.env.NODE_ENV !== "production" ? TopTermsContainer.propTypes = {
  desktopMode: bool,
  handleClose: func.isRequired,
  handleClickTopTerm: func.isRequired,
  list: oneOfType([array, object, node]),
  label: string
} : void 0;
TopTermsContainer.defaultProps = {
  desktopMode: false
};
export default TopTermsContainer;